/* ==========================================================================
   el-product-main.js — Afina PDP buy box (sections/el-product-main.liquid)

   Multi-option version of assets/afina-pdp.js (which stays untouched for the
   live templates). Same purchase rules:
   - plan "sub":  this product's variant + its selling plan
   - plan "once": the matching variant of the separate one-time product,
                  never with a selling plan
   - subscription-only gift variants are added once each, never on one-time
   - optional discount code applied after add, then the cart drawer repaints
   ========================================================================== */
(function () {
  'use strict';

  function initProductMain(root) {
    if (!root || root.hasAttribute('data-el-ready')) return;
    root.setAttribute('data-el-ready', '');

    var data = {};
    try { data = JSON.parse(root.querySelector('[data-el-product-data]').textContent); } catch (e) { return; }
    var variants = data.variants || [];
    if (!variants.length) return;

    var moneyFormat = data.moneyFormat || '${{amount}}';
    var config = root.querySelector('[data-el-buy-config]');
    var discountAmount = config ? parseInt(config.getAttribute('data-discount-amount') || '0', 10) || 0 : 0;
    /* A percentage promo ("20%" in the section) applies to each variant's own subscription price */
    var discountPct = config ? parseFloat(config.getAttribute('data-discount-pct') || '0') || 0 : 0;
    function promoOff(price) { return discountPct ? Math.floor(price * discountPct / 100) : discountAmount; }
    var form = root.querySelector('[data-el-form]');
    var q = function (selector) { return root.querySelector(selector); };
    var qa = function (selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); };

    /* Built-in strings come from locales/*.json (el.product.*) via [data-el-strings], so they
       follow the shop language. ES: a lang="es" wrapper on a page in another language (the
       older Spanish landers with Language = Español) forces the Spanish strings below. */
    var langEl = root.closest('[lang]');
    var pageLang = (document.documentElement.getAttribute('lang') || 'en').toLowerCase();
    var ES = !!(langEl && langEl !== document.documentElement && /^es\b/i.test(langEl.getAttribute('lang')) && !/^es\b/.test(pageLang));
    var S = {};
    try { S = JSON.parse((root.querySelector('[data-el-strings]') || {}).textContent || '{}'); } catch (e) { S = {}; }
    var T = ES ? {
      adding: 'Agregando…', added: 'Agregado al carrito',
      failed: 'Lo sentimos, no se pudo agregar a tu carrito. Inténtalo de nuevo.',
      wrong: 'Lo sentimos, algo salió mal al agregarlo a tu carrito. Actualiza la página e inténtalo de nuevo.'
    } : {
      adding: S.adding || 'Adding…', added: S.added || 'Added to cart',
      failed: S.failed || 'Sorry, this couldn’t be added to your cart. Please try again.',
      wrong: S.wrong || 'Sorry, something went wrong adding this to your cart. Please refresh the page and try again.'
    };
    function valueLabel(value) {
      var map = ES && window.elLangEs && window.elLangEs.finishes;
      if (map && map[value]) return map[value];
      /* display name from Theme settings > Product finishes, carried on the swatch */
      var swatch = qa('[data-option-label]').filter(function (el) { return el.getAttribute('data-option-value') === value; })[0];
      return (swatch && swatch.getAttribute('data-option-label')) || value;
    }

    /* Mirrors Liquid's money_without_trailing_zeros for the active market's format
       (copied from afina-pdp.js so both pages format prices identically). */
    function money(cents) {
      cents = parseInt(cents, 10) || 0;
      var negative = cents < 0; if (negative) cents = -cents;
      function group(s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
      function fmt(withDecimals, thousands, decimal) {
        if (!withDecimals) return group(String(Math.round(cents / 100)), thousands);
        if (cents % 100 === 0) return group(String(cents / 100), thousands);
        var parts = (cents / 100).toFixed(2).split('.');
        return group(parts[0], thousands) + decimal + parts[1];
      }
      var out = moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, fmt(false, '.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, fmt(false, ' ', ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fmt(true, '.', ','))
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, fmt(true, ' ', ','))
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, fmt(true, "'", '.'))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, fmt(false, ',', '.'))
        .replace(/\{\{\s*amount\s*\}\}/g, fmt(true, ',', '.'));
      return negative ? '-' + out : out;
    }

    /* ---------- state ---------- */
    var idInput = q('[data-el-variant-id]');
    var initialId = idInput ? parseInt(idInput.value, 10) : null;
    var initial = variants.filter(function (v) {
      return (v.sub && v.sub.id === initialId) || (v.once && v.once.id === initialId);
    })[0] || variants[0];
    var state = {
      options: initial.options.slice(),
      plan: root.getAttribute('data-plan') === 'once' ? 'once' : 'sub'
    };

    function matches(variant, options) {
      return variant.options.every(function (value, i) { return options[i] == null || value === options[i]; });
    }
    function currentVariant() {
      return variants.filter(function (v) { return matches(v, state.options); })[0] || null;
    }
    function hasPlan(variant) { return !!(variant && variant.sub && variant.sub.plan); }
    function purchase(variant) {
      if (!variant) return null;
      if (state.plan === 'sub' && hasPlan(variant)) return variant.sub;
      return variant.once || (hasPlan(variant) ? null : variant.sub);
    }
    function anyAvailable(variant) {
      return !!variant && !!((variant.sub && variant.sub.available) || (variant.once && variant.once.available));
    }

    function setText(selector, html, show) {
      qa(selector).forEach(function (el) {
        if (show === false) { el.hidden = true; el.innerHTML = ''; return; }
        el.hidden = false; el.innerHTML = html;
      });
    }

    /* ---------- render ---------- */
    function render() {
      var variant = currentVariant();
      if (variant && !hasPlan(variant) && state.plan === 'sub' && variant.once) state.plan = 'once';
      var active = purchase(variant);
      root.setAttribute('data-plan', state.plan);

      if (idInput) idInput.value = active ? active.id : '';
      var planInput = q('[data-el-selling-plan]');
      if (planInput) {
        var usePlan = state.plan === 'sub' && hasPlan(variant);
        planInput.value = usePlan ? variant.sub.plan : '';
        planInput.disabled = !usePlan;
      }

      if (variant) {
        var subPrice = variant.sub ? Math.max(0, variant.sub.price - (hasPlan(variant) ? promoOff(variant.sub.price) : 0)) : 0;
        setText('[data-el-price="sub"]', money(subPrice));
        setText('[data-el-compare="sub"]', money(variant.sub.compare), variant.sub.compare > subPrice);
        if (variant.once) {
          setText('[data-el-price="once"]', money(variant.once.price));
          setText('[data-el-compare="once"]', money(variant.once.compare), variant.once.compare > variant.once.price);
        }
        var ctaPrice = state.plan === 'sub' && hasPlan(variant) ? subPrice : (active ? active.price : 0);
        var ctaCompare = state.plan === 'sub' && hasPlan(variant) ? variant.sub.compare : (active ? active.compare : 0);
        setText('[data-el-cta-price]', money(ctaPrice));
        setText('[data-el-cta-compare]', money(ctaCompare), ctaCompare > ctaPrice);
      }

      var available = !!(active && active.available);
      var button = q('[data-el-add]'), label = q('[data-el-add-label]');
      if (button) button.disabled = !available;
      if (label) label.textContent = label.getAttribute(available ? 'data-default-label' : 'data-sold-out-label');
      renderStock(available);

      qa('[data-el-option-input]').forEach(function (input) {
        var position = parseInt(input.getAttribute('data-option-position'), 10) - 1;
        var value = input.getAttribute('data-option-value');
        var selected = state.options[position] === value;
        input.classList.toggle('is-selected', selected);
        input.setAttribute('aria-pressed', selected ? 'true' : 'false');
        var candidate = state.options.slice(); candidate[position] = value;
        var reachable = variants.filter(function (v) { return matches(v, candidate) && anyAvailable(v); }).length > 0;
        input.classList.toggle('is-unavailable', !reachable && !selected);
      });
      qa('[data-el-option-label]').forEach(function (el) {
        var position = parseInt(el.getAttribute('data-el-option-label'), 10) - 1;
        el.textContent = valueLabel(state.options[position] || '');
      });
      qa('[data-el-plan-option]').forEach(function (card) {
        card.setAttribute('aria-pressed', card.getAttribute('data-el-plan-option') === state.plan ? 'true' : 'false');
      });
      qa('[data-el-gift-subscription]').forEach(function (gift) {
        gift.setAttribute('data-locked', state.plan === 'sub' ? 'false' : 'true');
      });
    }

    /* ---------- stock + delivery date ---------- */
    function ordinal(n) {
      var s = ['th', 'st', 'nd', 'rd'], v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }
    function deliveryDate(days) {
      var date = new Date(), added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
      }
      if (ES) return date.getDate() + ' de ' + date.toLocaleDateString('es-US', { month: 'long' });
      if (/^en\b/.test(pageLang)) return date.toLocaleDateString('en-US', { month: 'long' }) + ' ' + ordinal(date.getDate());
      /* e.g. 30. Oktober / 30 de octubre / 30 oktober */
      return date.toLocaleDateString(pageLang, { day: 'numeric', month: 'long' });
    }
    function renderStock(available) {
      var stock = q('[data-el-stock]'); if (!stock) return;
      stock.classList.toggle('is-sold-out', !available);
      var status = stock.querySelector('[data-el-stock-status]');
      var delivery = stock.querySelector('[data-el-delivery]');
      if (status) status.textContent = stock.getAttribute(available ? 'data-in-stock-text' : 'data-sold-out-text');
      if (delivery) {
        var days = parseInt(stock.getAttribute('data-delivery-days') || '4', 10);
        delivery.textContent = available
          ? ' - ' + (stock.getAttribute('data-delivery-text') || '').replace('[date]', deliveryDate(days))
          : '';
      }
    }

    /* ---------- gallery ---------- */
    var track = q('[data-el-gallery-track]');
    var slides = qa('[data-el-gallery-slide]');
    var thumbs = qa('[data-el-gallery-thumb]');
    function setActiveThumb(index) {
      thumbs.forEach(function (thumb, i) {
        var on = i === index;
        thumb.classList.toggle('is-active', on);
        if (on) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
      });
    }
    function showSlide(index, smooth) {
      if (!track || !slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActiveThumb(index);
    }
    if (track && slides.length > 1) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var offset = track.scrollLeft, best = 0, bestDistance = Infinity;
          slides.forEach(function (slide, i) {
            var distance = Math.abs(slide.offsetLeft - slides[0].offsetLeft - offset);
            if (distance < bestDistance) { bestDistance = distance; best = i; }
          });
          setActiveThumb(best);
        });
      }, { passive: true });
      var start = slides.map(function (s) { return s.hasAttribute('data-el-start'); }).indexOf(true);
      if (start > 0) showSlide(start, false);

      /* Mouse drag (touch and trackpads already swipe natively; desktop browsers and
         phone simulators drag with the mouse). Snapping pauses while dragging, then the
         track settles on the nearest photo. */
      var dragX = 0, dragLeft = 0, dragging = false, dragMoved = false;
      track.addEventListener('dragstart', function (event) { event.preventDefault(); });
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true; dragMoved = false;
        dragX = event.clientX; dragLeft = track.scrollLeft;
      });
      track.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var dx = event.clientX - dragX;
        if (!dragMoved && Math.abs(dx) < 4) return;
        if (!dragMoved) {
          dragMoved = true;
          track.setPointerCapture(event.pointerId);
          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
          track.classList.add('is-dragging');
        }
        track.scrollLeft = dragLeft - dx;
      });
      var endDrag = function (event) {
        if (!dragging) return;
        dragging = false;
        if (!dragMoved) return;
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        track.classList.remove('is-dragging');
        var offset = track.scrollLeft, best = 0, bestDistance = Infinity;
        slides.forEach(function (slide, i) {
          var distance = Math.abs(slide.offsetLeft - slides[0].offsetLeft - offset);
          if (distance < bestDistance) { bestDistance = distance; best = i; }
        });
        /* a short flick still moves one photo in the drag direction */
        var dx = event.clientX - dragX;
        var from = Math.round((dragLeft) / Math.max(1, slides[Math.min(1, slides.length - 1)].offsetLeft - slides[0].offsetLeft));
        if (best === from && Math.abs(dx) > 40) best = Math.max(0, Math.min(slides.length - 1, from + (dx < 0 ? 1 : -1)));
        track.style.scrollBehavior = '';
        showSlide(best, true);
        setTimeout(function () { track.style.scrollSnapType = ''; }, 450);
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    }

    /* ---------- events (delegated) ---------- */
    /* ---------- accordions: smooth open / close ----------
       <details> works without JS; this only animates its height. The closed
       height is read with the "is-closing" class on (summary back to 62px)
       so the row lands exactly where a closed row sits. */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function toggleAccordion(details) {
      var summary = details.querySelector('summary');
      if (details._elAnimation) { details._elAnimation.cancel(); details._elAnimation = null; }
      var opening = !details.open || details.classList.contains('is-closing');
      var start = details.offsetHeight;
      var end;
      if (opening) {
        details.classList.remove('is-closing');
        details.open = true;
        end = details.offsetHeight;
      } else {
        details.classList.add('is-closing');
        end = summary.offsetHeight;
      }
      if (reduceMotion || !details.animate) { if (!opening) { details.open = false; details.classList.remove('is-closing'); } return; }
      details.style.overflow = 'hidden';
      var animation = details.animate({ height: [start + 'px', end + 'px'] }, { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
      details._elAnimation = animation;
      animation.onfinish = function () {
        details._elAnimation = null;
        details.style.overflow = '';
        if (!opening) { details.open = false; details.classList.remove('is-closing'); }
      };
    }

    root.addEventListener('click', function (event) {
      var accordionSummary = event.target.closest('.el-product-accordion__summary');
      if (accordionSummary) { event.preventDefault(); toggleAccordion(accordionSummary.parentElement); return; }
      var option = event.target.closest('[data-el-option-input]');
      if (option) {
        var position = parseInt(option.getAttribute('data-option-position'), 10) - 1;
        var next = state.options.slice(); next[position] = option.getAttribute('data-option-value');
        if (!variants.some(function (v) { return matches(v, next); })) {
          /* Combination does not exist: keep the clicked value, take the first variant that has it. */
          var fallback = variants.filter(function (v) { return v.options[position] === next[position] && anyAvailable(v); })[0]
            || variants.filter(function (v) { return v.options[position] === next[position]; })[0];
          if (fallback) next = fallback.options.slice();
        }
        state.options = next;
        render();
        var variant = currentVariant();
        if (variant) {
          /* Go to the variant's assigned photo: found by its media id, so it works whether
             the gallery shows the product photos or the design / custom images first */
          var target = variant.media_id != null ? slides.map(function (sl) { return sl.getAttribute('data-media-id'); }).indexOf(String(variant.media_id)) : -1;
          if (target >= 0) showSlide(target, true);
        }
        return;
      }
      var planCard = event.target.closest('[data-el-plan-option]');
      if (planCard) { state.plan = planCard.getAttribute('data-el-plan-option'); render(); return; }
      var oneTime = event.target.closest('[data-el-onetime-add]');
      if (oneTime) { addToCart('once', oneTime); return; }
      var thumb = event.target.closest('[data-el-gallery-thumb]');
      if (thumb) { showSlide(parseInt(thumb.getAttribute('data-el-gallery-thumb'), 10), true); return; }
      var play = event.target.closest('[data-el-video-play]');
      if (play) {
        var card = play.closest('[data-el-video]');
        var template = card && card.querySelector('[data-el-video-template]');
        if (!template) return;
        card.appendChild(template.content.cloneNode(true));
        card.classList.add('is-playing');
        var video = card.querySelector('video');
        if (video) { video.focus(); var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        play.remove();
      }
    });

    /* ---------- add to cart (same flow as afina-pdp.js) ----------
       plan "sub":  this variant + selling plan + subscription-only gifts
       plan "once": the matching one-time product variant only (no plan, no gifts) */
    function addToCart(plan, trigger) {
      var variant = currentVariant();
      var active = plan === 'sub' && hasPlan(variant) ? variant.sub : (variant && variant.once) || (hasPlan(variant) ? null : variant && variant.sub);
      if (!active || !active.available) return;
      var quantity = parseInt((q('[data-el-quantity]') || {}).value, 10) || 1;
      var item = { id: active.id, quantity: quantity };
      if (plan === 'sub' && hasPlan(variant)) item.selling_plan = variant.sub.plan;
      var items = [item];
      var giftIds = [];
      if (plan === 'sub' && config) {
        (config.getAttribute('data-gift-variants') || '').split(',').forEach(function (id) {
          id = parseInt(id, 10); if (id && giftIds.indexOf(id) === -1) giftIds.push(id);
        });
      }
      giftIds.forEach(function (id) { items.push({ id: id, quantity: 1 }); });

      /* Gifts must total exactly one each: add first, then re-read and correct. */
      function normalizeGifts(tries) {
        if (!giftIds.length || tries <= 0) return Promise.resolve();
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var updates = {}, kept = {};
            (cart.items || []).forEach(function (line) {
              if (giftIds.indexOf(line.id) === -1) return;
              if (!kept[line.id]) { kept[line.id] = true; if (line.quantity !== 1) updates[line.key] = 1; }
              else updates[line.key] = 0;
            });
            if (!Object.keys(updates).length) return null;
            return fetch('/cart/update.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function () { return normalizeGifts(tries - 1); });
          })
          .catch(function () {});
      }

      var label = q('[data-el-add-label]'), status = q('[data-el-status]');
      var usesButton = trigger && trigger.hasAttribute('data-el-add');
      trigger.disabled = true; trigger.setAttribute('aria-busy', 'true');
      if (usesButton && label) label.textContent = T.adding;

      function done() {
        trigger.removeAttribute('aria-busy');
        trigger.disabled = false;
        render();
      }
      function paint(sections) {
        if (config && config.getAttribute('data-after-add') === 'checkout') { window.location.href = '/checkout'; return; }
        done();
        if (status) status.textContent = T.added;
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) { window.location.href = '/cart'; return; }
        drawer.classList.remove('is-empty');
        /* Preferred: the drawer's own re-render, as the theme's product forms use it —
           it swaps #CartDrawer + the cart bubble, re-binds the overlay and opens. */
        if (typeof drawer.renderContents === 'function' && sections && sections['cart-drawer']) {
          try {
            if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(trigger);
            drawer.renderContents({ id: active.id, sections: sections });
            return;
          } catch (e) { /* fall through to the manual path */ }
        }
        try {
          if (sections && sections['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) bubble.innerHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
          }
          if (sections && sections['cart-drawer']) {
            var fresh = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
            var current = drawer.querySelector('#CartDrawer');
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          }
        } catch (e) {}
        var opened = false;
        if (typeof drawer.open === 'function') { try { drawer.open(trigger); opened = true; } catch (e) {} }
        /* Same fallback as the current header when the drawer element isn't upgraded */
        if (!opened) { drawer.classList.add('active', 'animate'); drawer.setAttribute('open', ''); document.body.classList.add('overflow-hidden'); }
      }

      var errorBox = q('[data-el-error]');
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
      /* A failed add stays on the page with Shopify's reason (e.g. sold out, subscription
         only) instead of sending the shopper to an empty cart. */
      function fail(message) {
        done();
        if (errorBox) { errorBox.textContent = message || T.failed; errorBox.hidden = false; }
      }

      /* One-time adds: confirm the cart got the one-time product this page names
         (data-el-onetime-product); anything else is taken straight back out. */
      var onceLink = q('[data-el-onetime-add]');
      var expectedHandle = item.selling_plan ? '' : ((onceLink && onceLink.getAttribute('data-el-onetime-product')) || '');
      function verifyOnce(response) {
        if (!expectedHandle || !response || !response.items) return response;
        var wrong = response.items.filter(function (line) { return line.id === item.id && line.handle && line.handle !== expectedHandle; });
        if (!wrong.length) return response;
        return fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: wrong[0].key, quantity: 0 })
        }).catch(function () {}).then(function () {
          var error = new Error('wrong product'); error.shopper = T.wrong; throw error;
        });
      }

      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      })
        .then(function (r) {
          if (r.ok) return r.json();
          return r.json().catch(function () { return {}; }).then(function (body) {
            var error = new Error('add failed'); error.shopper = body && (body.description || body.message); throw error;
          });
        })
        .then(function (response) { return verifyOnce(response); })
        .then(function (response) { return normalizeGifts(3).then(function () { return response; }); })
        .then(function (response) {
          var code = config && config.getAttribute('data-discount-code');
          if (!code) { paint(response.sections); return; }
          return fetch('/discount/' + encodeURIComponent(code), { redirect: 'manual' })
            .catch(function () {})
            .then(function () { return fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } }); })
            .then(function (r) { return r.json(); })
            .then(function (fresh) { paint(fresh || response.sections); })
            .catch(function () { paint(response.sections); });
        })
        .catch(function (error) { fail(error && error.shopper); });
    }

    /* The theme's global script.js binds its own AJAX add to every form[action="/cart/add"].
       Handle the submit here exclusively (capture phase + stopImmediatePropagation) so the
       product isn't added twice and the two handlers don't fight over the drawer. */
    if (form) form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(state.plan, q('[data-el-add]'));
    }, true);

    render();
  }

  /* el-product-switch.js sets up a swapped-in buy box with this */
  window.elInitProductMain = initProductMain;
  document.querySelectorAll('[data-el-product]').forEach(initProductMain);
  /* Theme Editor re-renders the section on every setting change */
  document.addEventListener('shopify:section:load', function (event) {
    initProductMain(event.target.querySelector('[data-el-product]'));
  });
})();
